import React, { useEffect, useState } from "react";
import { Col, Layout, Row, Typography } from "antd";
import { connect, useSelector } from "react-redux";
import { getDashboardDetails } from "../Redux/client/reducer";
import Header from "../Authorized/Header";
import Feedback from "../Utilities/Feedback";
import { Loading3QuartersOutlined } from "@ant-design/icons";
import { Helmet } from "react-helmet";
import ClientProfileCompletion from "./Profile/ClientProfileCompletion";

const ConsultantDashborad = (props) => {
  const [loading, setLoading] = useState(true);
  const { fetchDashboard } = props;
  useEffect(() => {
    const fetchDashboardDetails = async () => {
      await fetchDashboard();
      setLoading(false);
    };
    fetchDashboardDetails();
  }, [fetchDashboard]);
  const { dashboardDetails } = useSelector((state) => state.clientStore);
  const boxStyle = {
    margin: "1vh",
    marginBottom: "2vh",
    marginTop: "1vh",
    borderRadius: "16px",
    background: "#ffffff",
    width: "24vh",
    height: "16vh",
    padding: "1vh",
  };
  return (
    <Layout>
      <Helmet title="Dashboard || Unicon" />
      <Header />
      <Layout.Content>
        <Col>
          {loading ? (
            <Feedback
              icon={<Loading3QuartersOutlined spin />}
              title="Updating Dashboard"
            />
          ) : (
            <Col xl={{ span: 22 }} style={{ margin: "auto" }}>
              <ClientProfileCompletion />
              <Row justify="space-between">
                <Col style={boxStyle}>
                  <Typography.Title level={3} style={{ marginTop: "2vh" }}>
                    {dashboardDetails.no_of_jobs_posted}
                  </Typography.Title>
                  <Typography.Paragraph>Jobs Posted</Typography.Paragraph>
                </Col>
                <Col style={boxStyle}>
                  <Typography.Title level={3} style={{ marginTop: "2vh" }}>
                    {dashboardDetails.no_of_jobs_work_in_progress}
                  </Typography.Title>
                  <Typography.Paragraph>Jobs In Progress</Typography.Paragraph>
                </Col>
                <Col style={boxStyle}>
                  <Typography.Title level={3} style={{ marginTop: "2vh" }}>
                    {dashboardDetails.no_of_jobs_completed_successfully}
                  </Typography.Title>
                  <Typography.Paragraph>Jobs Completed</Typography.Paragraph>
                </Col>
                <Col style={boxStyle}>
                  <Typography.Title level={3} style={{ marginTop: "2vh" }}>
                    {dashboardDetails.no_of_jobs_not_yet_posted}
                  </Typography.Title>
                  <Typography.Paragraph>Jobs In Drafts</Typography.Paragraph>
                </Col>
                <Col style={boxStyle}>
                  <Typography.Title level={3} style={{ marginTop: "2vh" }}>
                    {dashboardDetails.no_of_jobs_dropped}
                  </Typography.Title>
                  <Typography.Paragraph>Jobs Dropped</Typography.Paragraph>
                </Col>
              </Row>
            </Col>
          )}
        </Col>
      </Layout.Content>
    </Layout>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchDashboard: () => dispatch(getDashboardDetails()),
  };
};

export default connect(null, mapDispatchToProps)(ConsultantDashborad);
